var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cartAddressResult)?_c('div',{staticClass:"body-2"},[(!_vm.cartAddressResult.status)?_c('div',{staticClass:"red--text"},[_vm._v(_vm._s(_vm.cartAddressResult.message))]):(_vm.cartAddressResult.message)?_c('div',{staticClass:"green--text"},[_vm._v(_vm._s(_vm.cartAddressResult.message))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }